import { TinyColor } from '@ctrl/tinycolor';
import { css, type Theme } from '@emotion/react';

const popoverWidth = 330;

export const popover = (theme: Theme) => css`
  width: ${popoverWidth}px;
  border-radius: 8px;

  box-shadow:
    0px 2px 4px
      ${new TinyColor(theme.colors.gray[900]).setAlpha(0.1).toRgbString()},
    0px 0px 11px 1px
      ${new TinyColor(theme.colors.gray[900]).setAlpha(0.1).toRgbString()};
`;

export const content = (theme: Theme) => css`
  background-color: ${theme.colors.gray[25]};
  border-bottom: 1px solid ${theme.colors.gray[100]};
  padding: 20px;
  overflow-wrap: anywhere;
`;

export const groupedItems = (theme: Theme) => css`
  border-bottom: 1px solid ${theme.colors.gray[100]};
`;

export const statusText = css`
  padding: 10px 0;
`;
